import { render, staticRenderFns } from "./round_edit.vue?vue&type=template&id=59c8482d&scoped=true&"
import script from "./round_edit.vue?vue&type=script&lang=js&"
export * from "./round_edit.vue?vue&type=script&lang=js&"
import style0 from "./round_edit.vue?vue&type=style&index=0&id=59c8482d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8482d",
  null
  
)

export default component.exports